import { IGetNewbuildingsForPromoSliderOnMapResponse } from '../../../common/repositories/newbuilding-search/entities/get_newbuildings_for_map_promo_slider/GetNewbuildingsForPromoSliderOnMapResponse';
import { INewbuildingForPromoInventory } from '../../types/promoInventory';

export function newbuildingsForPromoInventoryMapper(
  response: IGetNewbuildingsForPromoSliderOnMapResponse,
): INewbuildingForPromoInventory[] {
  return response.newbuildings.map(item => {
    if (item.undergroundInfo) {
      return { ...item, undergroundInfo: { ...item.undergroundInfo, lineColor: `#${item.undergroundInfo.lineColor}` } };
    }

    return item;
  });
}
